import { render, staticRenderFns } from "./S2SClientSettings.vue?vue&type=template&id=240306f7&"
import script from "./S2SClientSettings.vue?vue&type=script&setup=true&lang=js&"
export * from "./S2SClientSettings.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports